import React, { useState } from "react";
import { setStartDate, setEndDate, runQuery } from "../../../redux/action";
import { RootState } from "../../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import _ from "lodash";
import {
  ZalesSignageConfig,
  SignageEventTypes,
} from "../../kayJwellers/events.config";
import CommonTable from "../../../components/Table/CommonTable";
import "moment-timezone";
import moment from "moment";
import { downloadCSV } from "../../kayJwellers/helper";
import useClasses from "../../../common/UseClasses";
import { Button, Grid, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";

type PropsFromRedux = ConnectedProps<typeof connector>;
type SinageTabProps = PropsFromRedux & {};

const useStyles = () => ({
  container: {
    height: 440,
  },

  csvButton: {
    backgroundColor: "rgba(107,147,57,1)",
    height: 30,
    width: 80,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    color: "white",
    textDecorationLine: "none",
    marginBottom: 5,
    fontSize: 12,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
const SinageTab: React.FC<SinageTabProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
  runQuery,
  ...rest
}) => {
  // const classes = useStyles();
  const classes: any = useClasses(useStyles);

  const [eventsData, setEventsData] = useState<any>({});
  const [totalCount, setTotalCount] = useState<{ [key: string]: number }>({});

  const handleFromDateChange = (date: any) => {
    setStartDate(date.$d);
  };
  const handleToDateChange = (date: any) => {
    setEndDate(date.$d);
  };

  const categorydata: any = {};
  let count: { [key: string]: number } = {};
  const getSummary = async () => {
    const tableData: any = {
      tableHeader: [
        { label: "Event Name", key: "event_name" },
        { label: "Event Count", key: "value" },
      ],
      tableRow: [],
    };

    const startDate = moment(startDateObj).format("YYYYMMDD");
    const endDate = moment(endDateObj).format("YYYYMMDD");

    let query = `SELECT event_name, count(1) as value
                        FROM \`zales-cms-prod.analytics_205854940.events_*\`,
                        UNNEST(event_params) AS param WHERE (param.key = 'STORE_NAME' or param.key = 'vv_store_name' )
                        AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
                        group by 1 order by value desc`;

    const data: any = await runQuery({ query });

    query = `SELECT SUM(CAST(param1.value.string_value AS FLOAT64 )) as value ,count(param1.value.string_value) as session_count FROM \`zales-cms-prod.analytics_205854940.events_*\`, UNNEST(event_params) AS param1,UNNEST(event_params) AS param WHERE (param.key = 'vv_store_name') AND (param1.key = 'vv_session_duration_time_in_secs_string') AND event_name = "vv_user_session_end" AND event_date >= '${startDate}' AND event_date <= '${endDate}'`;

    const avgSessionData: any = await runQuery({ query });

    const startData: any = {};

    const EventsData: any = [];

    SignageEventTypes.forEach((eventobj: any) => {
      const eventname = eventobj.name;
      startData[eventname] = 0;
    });

    data.forEach((row: any) => {
      const eventname = row.event_name;
      const eventvalue = row.value;

      let eventobj: any = SignageEventTypes.find((eventtype: any) =>
        eventtype.events.includes(eventname)
      );

      if (eventobj) startData[eventobj.name] += parseInt(eventvalue);
    });

    Object.keys(startData).forEach((element: any) => {
      let eventobj: any = SignageEventTypes.find(
        (eventtype: any) => element === eventtype.name
      );
      if (eventobj) {
        const obj = {
          event_name: eventobj.label,
          value: startData[element],
        };

        EventsData.push(obj);
      }
    });
    EventsData.push({
      event_name: "Average Session Time",
      value:
        avgSessionData[0]["value"] != null
          ? (
              avgSessionData[0]["value"] / avgSessionData[0]["session_count"]
            ).toFixed(2)
          : "N/A",
    });
    tableData.tableRow.push(...EventsData);

    categorydata["Zales Signage Summary"] = tableData;

    count["Zales Signage Summary"] = 0;
  };

  const getCuralateDataBySession = async () => {
    const startDate = moment(startDateObj).format("YYYYMMDD");
    const endDate = moment(endDateObj).format("YYYYMMDD");

    let query = `select event_timestamp, FORMAT_DATE('%m-%d-%Y', PARSE_DATE('%Y%m%d', event_date)) as date, FORMAT_TIME('%T', TIME(TIMESTAMP_MICROS(event_timestamp))) time,event_name, param.value.string_value as storename, param1.value.string_value as session_id
      FROM \`zales-cms-prod.analytics_205854940.events_*\`,
      UNNEST(event_params) AS param, UNNEST(event_params) AS param1 WHERE event_name='curalate_show_request' and (param.key = 'STORE_NAME' or param.key = 'vv_store_name' ) and param1.key='session_id'
      AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
      `;

    const sessions: any = await runQuery({ query });

    query = `Select param1.value.string_value as sessionid, count(param1.value.string_value) as count FROM \`zales-cms-prod.analytics_205854940.events_*\`,
      UNNEST(event_params) as param, UNNEST(event_params) AS param1 where event_name='curalate_item_show_request' and (param.key = 'STORE_NAME' or param.key = 'vv_store_name' ) and param1.key='session_id'
      AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
      group by 1`;

    const sessionids: any = await runQuery({ query });
    const eventsData: any = [];
    sessions.forEach((obj: any) => {
      const sessionid = obj.session_id;
      const sessionobj: any = sessionids.find(
        (session: any) => session.sessionid === sessionid
      );
      const count = sessionobj ? sessionobj.count : 0;
      obj["event_timestamp"] = moment(obj["event_timestamp"] / 1000)
        .tz("America/Los_Angeles")
        .format("MM-DD-YYYY hh:mm:ss A");
      eventsData.push({ ...obj, item_requests: count });
    });

    return eventsData;
  };

  const getSinageData = async () => {
    await getSummary();

    const curalateData: any = await getCuralateDataBySession();
    const startDate = moment(startDateObj).format("YYYYMMDD");
    const endDate = moment(endDateObj).format("YYYYMMDD");

    for (const product of ZalesSignageConfig) {
      /* loop over each table configuration defined into events.config */

      count[product.label] = 0;

      const tableData: any = {
        tableHeader: [],
        tableRow: [],
      };

      let query = `${product.query} and event_date >= '${startDate}' AND  event_date <= '${endDate}' ${product.appendquery}`; /* dynamically loads query from configuration file and forms query */
      const result: any = await runQuery({
        query,
      }); /*function call to execute query and retrieve data */

      result.forEach((resultdata: any, resultindex: number) => {
        /* loop over each object from response received from query */

        if (resultdata["value"]) count[product.label] += resultdata["value"];

        if (resultdata["event_timestamp"])
          resultdata["event_timestamp"] = moment(
            resultdata["event_timestamp"] / 1000
          )
            .tz("America/Los_Angeles")
            .format("MM-DD-YYYY hh:mm:ss A");

        tableData.tableRow.push(resultdata); /* add row into  data array */
      });

      tableData.tableHeader.push(...product.headers);

      if (product.mergedata) tableData.tableRow.push(...curalateData);
      categorydata[product.label] = tableData; /* map table dynamically */
    }

    setEventsData(
      categorydata
    ); /* update state variable with data for each table */
    setTotalCount(
      count
    ); /* update total count for each table of state variable */
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          flex: 1,
          padding: 16,
          alignItems: "center",
          marginBottom: 20,
          marginTop:20
        }}>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="From Date"
format="MM/DD/YYYY"
value={dayjs(startDateObj)}
sx={{marginRight:'10px'}}
onChange={handleFromDateChange}
/>
<DatePicker
label="To Date"
format="MM/DD/YYYY"
value={dayjs(endDateObj)}
sx={{marginRight:'10px'}}
onChange={handleToDateChange}
/>
    </LocalizationProvider>

        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="From Date"
            format="MM/dd/yyyy"
            value={startDateObj}
            onChange={handleFromDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            autoOk={true}
          />

          <KeyboardDatePicker
            style={{ marginLeft: 16 }}
            margin="normal"
            id="date-picker-dialog"
            label="To Date"
            format="MM/dd/yyyy"
            value={endDateObj}
            onChange={handleToDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            autoOk={true}
          />
        </MuiPickersUtilsProvider> */}

        <Button
          variant="contained"
          color="secondary"
          sx={{
            height: 40,
            marginLeft: 5,
            width: 150,
          }}
          onClick={() => getSinageData()}>
          Apply
        </Button>
      </div>
      <Grid container spacing={4}>
        {eventsData
          ? Object.keys(eventsData)?.map((row: string, i: number) => {
              let tabledata = eventsData[row];
              return (
                <Grid item md={12} xs={6} lg={6} key={i}>
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: 1 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 800 }} color="primary">
                        {`${row}`} <br />{" "}
                        {totalCount[row] === 0
                          ? ""
                          : `(Total Count : ${totalCount[row]}) `}
                      </Typography>
                    </div>
                    <div style={{ display:'flex',flexDirection:'column', justifyContent:'center', alignItems:'center' }}>
                      <Button
                        variant="contained"
                        color="primary"
                          sx={{
                          height:40,
                          width:200,
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          }}
                        onClick={() =>
                          downloadCSV(
                            tabledata.tableRow,
                            row,
                            tabledata.tableHeader
                          )
                        }>
                        {" "}
                        Download CSV
                      </Button>
                    </div>
                  </div>
                  {tabledata ? <CommonTable tableData={tabledata} /> : null}
                </Grid>
              );
            })
          : null}
      </Grid>
    </div>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
});

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
  runQuery,
});

export default connector(SinageTab);
